 import { UserFilterField, UserFilterTag, UserFilterOperator } from "@/hooks/useAdminUsers";
import { UserColumnFilters } from "./UserColumnFilters";

interface UsersFilterProps {
  filterTags: UserFilterTag[];
   addFilter: (field: UserFilterField, value: string, operator?: UserFilterOperator) => void;
  removeFilter: (tagId: string) => void;
  clearAllFilters: () => void;
}

export const UsersFilter = ({
  filterTags,
  addFilter,
  removeFilter,
  clearAllFilters,
}: UsersFilterProps) => {
  return (
    <UserColumnFilters
      filterTags={filterTags}
      addFilter={addFilter}
      removeFilter={removeFilter}
      clearAllFilters={clearAllFilters}
    />
  );
};
